import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbPaginationModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {MergeModalComponent} from '../modals/merge-modal/merge-modal.component';
import {FormsModule} from '@angular/forms';
import {DatePipe, NgForOf, NgIf, TitleCasePipe} from '@angular/common';
import {SearchComponent} from '@shared/search/search.component';
import {TableSortOrderComponent} from '@shared/table-sort-order/table-sort-order.component';
import {HelpDocsLinksComponent} from '@shared/help-docs-links/help-docs-links.component';
import {IsEmptyPipe} from '@shared/pipes/is-empty.pipe';
import {DisplayPipe} from '@shared/pipes/display.pipe';
import {ToastService} from '@shared/services/toast.service';
import {GenericModalComponent} from '@shared/modals/generic-modal/generic-modal.component';
import {SummaryModalComponent} from '@shared/modals/summary-modal/summary-modal.component';
import {SitesService} from '@shared/services/sites.service';
@Component({
    selector: 'app-site-list',
    templateUrl: './site-list.component.html',
    styleUrls: ['./site-list.component.scss'],
    imports: [
        FormsModule,
        TableSortOrderComponent,
        SearchComponent,
        HelpDocsLinksComponent,
        IsEmptyPipe,
        NgIf,
        DisplayPipe,
        DatePipe,
        NgbTooltipModule,
        NgForOf,
        RouterLink,
        TitleCasePipe,
        NgbPaginationModule
    ]
})
export class SiteListComponent implements OnInit {
  currentDataset: string;
  actionSelected = {value: 'default', label: 'Actions'};
  bulkOptions = [{value: 'default', label: 'Actions'}, {value: 'delete', label: 'Delete'},
    {value: 'merge', label: 'Merge'}];
  isAllSelected = false;
  currentPage = 1;
  showAll = false;

  constructor(public modal: NgbModal, public route: ActivatedRoute, public router: Router,
              public sitesService: SitesService, public toast: ToastService, public http: HttpClient) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.currentDataset = params.dataset;
      this.sitesService.searchParam.dataset = this.currentDataset;
      this.sitesService.searchParam.verified = true;
      this.sitesService.searchParam.search = params.search;
      this.sitesService.search().subscribe();
    });


  }

  changeOrder(order) {
    this.sitesService.searchParam.ordering = order;
    this.sitesService.search().subscribe()
  }
  switchPage() {
    this.sitesService.searchParam.page = this.currentPage;
    this.sitesService.search().subscribe();
  };

  selectAll() {
    var toggleStatus = this.isAllSelected;
    this.sitesService.sites.forEach((site) => {
      site.selected = toggleStatus;
    });
  };


  selectionChange() {
    var selectedSites = this.sitesService.sites.filter(x => x.selected === true);
    var siteNames = [];
    selectedSites.forEach((site) => {
      siteNames.push(site.primary_name);
    });

    if (this.actionSelected.value === 'delete') {
      if (selectedSites.length <= 0) {
        this.toast.warning("You must select at least one site to delete.");
      } else {
        var confirmDialog = this.modal.open(GenericModalComponent, {backdrop: 'static'});
        confirmDialog.componentInstance.text = 'Are you sure you want to remove <b>' + siteNames.join(',') + '</b> from this site?'
        confirmDialog.result.then(() => {
          selectedSites.forEach((site) => {
            this.http.delete(`${environment.baseUrl}/sites/${site.globalid}`).subscribe(() => {
              var index = this.sitesService.sites.indexOf(site);
              this.sitesService.sites.splice(index, 1);
            });
          });
        });
      }
    } else if (this.actionSelected.value === 'merge') {
      if (selectedSites.length <= 1) {
        this.toast.warning("You must select at least two sites to merge.");
      } else {
        var mergeDialog = this.modal.open(MergeModalComponent, {backdrop: 'static', size: 'lg'});
        mergeDialog.componentInstance.selectedSites = selectedSites;
      }
    }
    this.actionSelected = {value: 'default', label: 'Actions'};
  };

  showAllPage() {
    this.showAll = true;
  };


  openSummaryModal(site: any) {
    const summaryModal = this.modal.open(SummaryModalComponent);
    summaryModal.componentInstance.item = site;
  }

  protected readonly SitesService = SitesService;
}
